import { TableInner } from '@chocolate-soup-inc/cs-frontend-components';
import clsx from 'clsx';
import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { TListEmployee, useQueryAllEmployees } from '../../../entities/employee/shared';
import { usePrivateCompanyContext } from '../../../routes/outlets/PrivateCompanyOutlet';
import { EMPLOYEES_PATH, EMPLOYEE_ACCOUNT_PATH, EMPLOYEE_PATH } from '../../../routes/paths';
import { useLayoutContext } from '../../shared/Layout';

import { isAddressValid } from '../../../entities/address/shared';
import { TDeliveryMethod } from '../../../generated/graphql';
import styles from './EmployeesWithAddressAlert.module.scss';

type TEmployeesWithAddressAlertProps = {
  className?: string;
  backTo?: string;
};

export const EmployeesWithAddressAlert = (props: TEmployeesWithAddressAlertProps) => {
  const { className, backTo } = props;
  const { className: layotuClassName } = useLayoutContext();

  const navigate = useNavigate();

  const { id: companyId, deliveryMethod } = usePrivateCompanyContext();

  const { data } = useQueryAllEmployees({
    companyId
  });

  const employeesWithAddressAlert: TListEmployee[] = useMemo(() => {
    return _.compact(data?.listCompanyEmployees.items || []).filter((e) => {
      return e.address?.alert != null || !isAddressValid(e.address);
    });
  }, [data?.listCompanyEmployees.items]);

  const getRowId = useCallback((employee: TListEmployee) => {
    return employee.id;
  }, []);

  const onRowClick = useCallback(
    (id: string) => {
      navigate(
        generatePath(`${EMPLOYEES_PATH}/${EMPLOYEE_PATH}/${EMPLOYEE_ACCOUNT_PATH}`, {
          employeeId: id
        }),
        {
          state: {
            backTo
          }
        }
      );
    },
    [navigate, backTo]
  );

  if (employeesWithAddressAlert.length === 0 || deliveryMethod != TDeliveryMethod.Home) return null;

  return (
    <div className={clsx(layotuClassName, className, styles.withAddressAlert)}>
      <div className={clsx(styles.withAddressAlertContent)}>
        <h2 className={styles.title}>Not validated addresses.</h2>
        <p className={styles.supportText}>{`These employees addresses are filled but we could not validate them on Google Maps. Please make sure they are correct.`}</p>
        <TableInner<TListEmployee>
          enableSorting={true}
          defaultSorting={{ id: 'fullName', desc: false }}
          data={employeesWithAddressAlert}
          expandable={false}
          fixedHeader={false}
          getRowId={getRowId}
          hoverableRows={true}
          virtual={false}
          onRowClick={(row) => {
            onRowClick(row.original.id);
          }}
          columns={[
            {
              header: 'Full Name',
              accessorKey: 'fullName'
            }
          ]}
        />
      </div>
    </div>
  );
};
